module.exports = __webpack_public_path__ + "static/media/F11-Bootstrap.087292cd.svg";